// An alert draft on its way from an Orpheus card to the alert form (v3 `alertFormHandoff.js`,
// KUR-9): the card hands it over right before it navigates; the Alerts page takes it once, when
// it opens its form from `?create=alert` / `?edit_alert=`. Owned here, not in Alerts, so the arrow
// between the two islands keeps pointing one way (Alerts already reads Orpheus's barrel).
let pending: Record<string, unknown> | null = null

export function handOffAlertDraft(values: Record<string, unknown> | null | undefined): void {
  pending = values ?? null
}

export function takeAlertDraft(): Record<string, unknown> | null {
  const values = pending
  pending = null
  return values
}
